const theme = {
    black: 'black',
    white: 'white',
    transparent: 'transparent',
    green: '#57B093',
    green2: '#4DA287',
    darkGreen: '#236650',
    blue: '#3A869E',
    darkBlue: '#275D6E',
    darkBlue2: '#3C7689',
    darkSlateBlue: '#275d6e',
    blueLight: '#EAFBF7',
    blueLight2: '#CEF2EB',
    blueLight3: '#B1E6DB',
    brown: '#7C7C7C',
    darkBrown: '#2B2D2E',
    orange: '#FF9933',
    orange2: '#EA8E31',
    orange3: '#D87C20',
    yellow: '#FFFABD',
    yellow2: '#E6DD70',
    red: '#DE4C4A',
    red2: '#E04A46',
    red3: '#C74240',
    skin: '#E9BE93',
    dark: '#2B2D2E',
    darkGrey: '#4B616A',
    grey: '#C7D1D4',
    grey2: '#B3BDC0',
    grey3: '#A0A4A6',
    greyLight: '#FAFCFD',
    greyLight2: '#F4F5F9',
    greyLight3: '#E6ECEC',
    greyLight4: '#E5E7ED',
    lightGreyBlue: '#B3BDC0',
    // NEW 5.0
    lightGrey3: '#F5F7FE',
    lightBlue1: '#85D4C4',
    lightBlue2: '#CEF2EB',
    lightGreen: '#98B836',
}

export default theme
